<template>
    <div class="single-psp">
        <div v-if="method.key === 'atlas'" class="psp-icon">
            <svg width="58" height="24" viewBox="0 0 58 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Stripe logo_large" clip-path="url(#clip0_3072_90682)">
                <path id="Vector" d="M4.05852 9.36199C4.05852 8.74006 4.57184 8.50075 5.42218 8.50075C6.64125 8.50075 8.18121 8.86767 9.40039 9.52157V5.77347C8.06898 5.2472 6.75359 5.03985 5.42218 5.03985C2.16562 5.03985 0 6.73049 0 9.55353C0 13.9553 6.09578 13.2536 6.09578 15.1516C6.09578 15.8851 5.45422 16.1244 4.55582 16.1244C3.22441 16.1244 1.52395 15.5821 0.176408 14.8485V18.6444C1.66832 19.2823 3.17625 19.5534 4.55582 19.5534C7.89246 19.5534 10.1864 17.9107 10.1864 15.0558C10.1704 10.3031 4.05852 11.1483 4.05852 9.36199ZM14.9027 1.8501L10.9885 2.67939L10.9725 15.4545C10.9725 17.8151 12.7532 19.5534 15.1273 19.5534C16.4427 19.5534 17.4052 19.3142 17.9345 19.0271V15.7895C17.4213 15.9968 14.8866 16.7304 14.8866 14.37V8.7081H17.9345V5.311H14.8866L14.9027 1.8501ZM22.9236 6.49118L22.6669 5.311H19.2019V19.2663H23.2123V9.80865C24.1587 8.58059 25.7629 8.80386 26.2602 8.97925V5.311C25.7469 5.11958 23.87 4.76869 22.9236 6.49118ZM27.2387 5.311H31.2652V19.2663H27.2387V5.311ZM27.2387 4.09887L31.2652 3.23763V0L27.2387 0.84532V4.09887ZM39.6389 5.03985C38.0668 5.03985 37.0562 5.77347 36.4948 6.28394L36.2862 5.29508H32.7571V23.8914L36.7675 23.0462L36.7836 18.5327C37.3611 18.9474 38.2112 19.5375 39.6229 19.5375C42.4944 19.5375 45.1092 17.2408 45.1092 12.185C45.0932 7.55977 42.4463 5.03985 39.6389 5.03985ZM38.6765 16.0287C37.73 16.0287 37.1684 15.6938 36.7836 15.2791L36.7675 9.36199C37.1846 8.89952 37.7621 8.58059 38.6765 8.58059C40.1362 8.58059 41.1469 10.2073 41.1469 12.2966C41.1469 14.4338 40.1523 16.0287 38.6765 16.0287ZM57.75 12.3445C57.75 8.26155 55.7608 5.03985 51.959 5.03985C48.1409 5.03985 45.8309 8.26166 45.8309 12.3126C45.8309 17.1132 48.5582 19.5375 52.4722 19.5375C54.3812 19.5375 55.825 19.1068 56.9158 18.5008V15.311C55.8251 15.8533 54.5737 16.1882 52.9856 16.1882C51.4295 16.1882 50.05 15.6459 49.8736 13.764H57.718C57.718 13.5565 57.75 12.7272 57.75 12.3445ZM49.8254 10.8294C49.8254 9.02714 50.9323 8.27747 51.943 8.27747C52.9214 8.27747 53.9642 9.02714 53.9642 10.8294H49.8254Z" fill="#6772E5"/>
                </g>
                <defs>
                <clipPath id="clip0_3072_90682">
                <rect width="57.75" height="24" fill="white"/>
                </clipPath>
                </defs>
            </svg>
        </div>
        <h5 class="title body__medium">{{tokens.newDesign.otherDetails}}</h5>
        <div class="order-info">
            <div class="currencies" @click="toggler()">
                <BaseSelectBox
                    v-model="currency"
                    :placeholder="currency"
                    :state="state"
                    :hide-arrow="true"
                    :title="tokens.orderMenu.currency"
                    :design="'deposit'"
                    :placement="'full'"
                    :options="currencies.map(item => ({
                            key: item,
                            title: item
                        }))"
                    @update="changeCurrency"
                >
                    <template #placeholder>
                        <div class="placeholder">
                            <div class="icon">
                                <img :src="staticBase+`currencies/${currency ? currency : 'USD'}.png`" alt="">
                                <p class="body__large">{{currency}}</p>
                            </div>
                            <span class="material-symbols-outlined">{{state ? 'arrow_drop_up' : 'arrow_drop_down'}}</span>
                        </div>
                    </template>
                    <template #option="{option}">
                        <img :src="staticBase+`currencies/${option.key ? option.key : 'USD'}.png`" alt="">
                        <div class="name">{{ option.title }}</div>
                    </template>
                </BaseSelectBox>
            </div>
            <div class="input-wrapper">
                <BaseInput 
                    class="amount" 
                    v-model="amount" 
                    :type="'number'" 
                    :title="tokens.newDesign.amount" 
                    :placeholder="'0.00'"
                >
                    <template #icon>
                        <p class="body__large">{{ currencySign(currency) }}</p>
                    </template>
                </BaseInput>

                <div v-if="convertOnUsd" class="converted-price body__small">
                    <span>Convert in USD: ≈ </span>
                    <span>{{ converting }}</span>
                </div>
            </div>
        </div>
        <BaseModalChipsList class="chips">
            <template #content>
                <BaseModalChipsListItem
                    v-for="deposit in depositButtonsList"
                    :key="deposit.amount"
                    @click.native="setCurrency(deposit.amount)"
                >
                    <template #content>
                        <p>{{deposit.amountStr}}</p>
                    </template>
                </BaseModalChipsListItem>
            </template>
        </BaseModalChipsList>
        <div class="action">
            <p class="info body__extrasmall">*{{tokens.newDesign.depositText}}</p>
            <BaseButton
                :button-text="tokens.newDesign.continue"
                :button-style="'filled-tertiary'"
                :disabled="!amount || disabledButton"
                @click.native="makeDeposit"
            />
        </div>
    </div>
</template>

<script>
import BaseInput from "@/new-design/shared/ui/Inputs/BaseInput.vue"
import {currencySign} from "@/common/helpers"
import BaseModalChipsListItem from "@/new-design/shared/ui/chips/BaseModalChipsListItem.vue"
import BaseModalChipsList from "@/new-design/shared/ui/chips/BaseModalChipsList.vue"
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue"
import BaseSelectBox from "@/new-design/shared/ui/Inputs/BaseSelectBox.vue"
import toggler from "@/new-design/shared/mixins/toggler"
import {DEPOSIT_BUTTONS, MAXIMUM_DEPOSIT, MINIMUM_DEPOSIT} from "@/common/config"
import {mapGetters} from "vuex";

export default {
    name: "SinglePspMethod",
    components: {BaseSelectBox, BaseButton, BaseModalChipsList, BaseModalChipsListItem, BaseInput},
    mixins: [toggler],
    mounted() {
        this.init()
    },
    props: {
        currencies: {
            type: Array,
            default: () => []
        },
        method: {
            type: Object,
            default: () => {
            }
        },
        disabledButton: {
            type: Boolean,
            default: false
        },
        convertOnUsd: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            amount: null,
            selectedCurrency: '',
        }
    },
    computed: {
        ...mapGetters(['conversions', 'user', 'pspList','tokens','staticBase']),
        currency: {
            get() {
                return this.selectedCurrency || (this.currencies.length ? this.currencies[0] : '')
            },
            set(value) {
                this.selectedCurrency = value
            }
        },
        depositButtonsList() {
            let buttons = []

            if (!this.method || !this.pspList || !DEPOSIT_BUTTONS[this.currency]) {
                return buttons
            }

            const methodConfig = this.pspList.find(data => data.name === this.method.key) || {}

            let minimum = methodConfig.deposit_min || MINIMUM_DEPOSIT
            let maximum = methodConfig.deposit_max || MAXIMUM_DEPOSIT

            if (this.user && this.user.min_deposit !== 0) {
                minimum = this.user.min_deposit
            }

            if (this.method.key === 'cc-ext3' && methodConfig.onlyButtons) {
                methodConfig.onlyButtons.forEach((button) => {
                    buttons.push({
                        amount: button.value,
                        amountStr: currencySign(this.currency) + button.value.toLocaleString('en', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        }),
                    })
                })
                return buttons
            }

            Object.keys(DEPOSIT_BUTTONS).forEach(depositCurrency => {
                let depositButtons = DEPOSIT_BUTTONS[depositCurrency]

                if (depositCurrency === 'RUB' && this.conversions[depositCurrency]) {
                    const convertedMin = (minimum / this.conversions[depositCurrency]).toFixed(4)
                    if (!depositButtons.includes(+convertedMin)) {
                        depositButtons.push(+convertedMin)
                    }
                } else {
                    if (!depositButtons.includes(minimum)) {
                        depositButtons.push(minimum)
                    }
                }

                depositButtons.sort((a, b) => a - b)
            })

            for (const amount of DEPOSIT_BUTTONS[this.currency]) {
                const convertedAmount = amount * (this.conversions[this.currency] || 1)

                if (convertedAmount >= minimum && convertedAmount <= maximum) {
                    buttons.push({
                        amount,
                        amountStr: currencySign(this.currency) + amount.toLocaleString('en', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        })
                    })
                }
            }

            return buttons
        },

        converting() {
            if (!this.convertOnUsd) {
                return this.amount
            }
            let currentCurrency = this.currency;

            switch (currentCurrency) {
                case 'USDT-TRC20':
                case 'USDT-ERC20':
                    currentCurrency = 'USDT'
                    break;
                case 'USDC-ERC20':
                    currentCurrency = 'USDC'
                    break;
            }

            return (this.amount * (this.conversions[currentCurrency] || 1)).toLocaleString('en', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })
        }
    },
    methods: {
        currencySign,
        init() {
            this.amount = null
        },
        changeCurrency(currency) {
            this.currency = currency
        },
        makeDeposit() {
            this.$emit('update', {
                info: {
                    amount: this.amount,
                    currency: this.currency,
                }
            })
        },
        setCurrency(amount) {
            this.amount = amount
        }
    },
    watch: {
        'method': {
            handler() {
                this.init();
                this.selectedCurrency = ''
            }
        }
    }
}
</script>

<style scoped>
.title {
    color: var(--System-OnSurface);
    padding: 16px 0;
    text-align: left;
}

.chips {
    padding: 12px 0 16px;
}

.order-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.currencies {
    position: relative;
    cursor: pointer;
}

.input-wrapper{
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.input-wrapper .converted-price {
    span:last-child {
        color: var(--System-OnSurface);
    }
}

img {
    width: 20px;
    height: 20px;
    object-fit: cover;
}

.action {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
}

.placeholder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 8px 8px 8px;
    outline: none;
    height: 100%;
    background: transparent;
    color: var(--System-OnSurface);
    width: 100%;
    transition: all .3s ease;
    border-radius: 4px;
    border: 1px solid var(--System-Outline);
}

.icon {
    display: flex;
    align-items: center;
    gap: 4px;
}

.info {
    text-align: left;
}

.psp-icon{
    padding: 24px 0 8px;
    text-align: left;
}

@media (max-width: 468px) {
    .title {
        text-align: left;
    }

    .order-info {
        grid-template-columns: 1fr !important;
    }

    .action {
        gap: 24px;
    }
}
</style>
